
<template>
	<i>
		<svg width='24' height='24' viewBox='0 0 24 24' fill='none'><path d='M6.29006 8.11L10.1801 12L6.29006 15.89C5.90006 16.28 5.90006 16.91 6.29006 17.3C6.68006 17.69 7.31006 17.69 7.70006 17.3L12.2901 12.71C12.6801 12.32 12.6801 11.69 12.2901 11.3L7.70006 6.7C7.31006 6.31 6.68006 6.31 6.29006 6.7C5.91006 7.09 5.91006 7.73 6.29006 8.11ZM17.0001 6C17.5501 6 18.0001 6.45 18.0001 7V17C18.0001 17.55 17.5501 18 17.0001 18C16.4501 18 16.0001 17.55 16.0001 17V7C16.0001 6.45 16.4501 6 17.0001 6Z' fill='#323232'/></svg>
	</i>
</template>

<script>
export default {
	name: `b-new-b-icon-last-page`,
	components: {},
	computed: {},
	props: {
		spin: {
			type: Boolean,
			default: false
		}
	},
	mounted() {
		if(this.spin){
			this.$nextTick(() => this.$el.classList.add('spin'));
		}
	}
};
</script>

<style scoped lang="scss">
i {
	display: inline-block;
	vertical-align: middle;

	svg {
		width: 1em;
		height: auto;
		display: block;
	}

	*:not([fill='none']) {
		fill: currentColor;
	}
}

path.a {
	fill: none;
}

.spin {
	animation: rotation 2s infinite linear;
}

@keyframes rotation {
	from {
		transform: rotate(0deg);
	}
	to {
		transform: rotate(359deg);
	}
}
</style>

<docs>
    IconLastPage

    ```js
    <b-new-b-icon-last-page />
    ```
</docs>


